var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var OrderedList = function OrderedList(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 30 30' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M8 21h2l-1 1 1 1H8v1h3v-1l-1-1 1-1v-1H8v1zm0-6h2.1L8 17v1h3v-1H9.1l1.9-2v-1H8v1zm1-3h1V8H8v1h1v3zm4-1h10V9H13v2zm0 6h10v-2H13v2zm0 6h10v-2H13v2z' })
    )
  );
};
/*eslint-enable */

export default OrderedList;
//# sourceMappingURL=OrderedList.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/OrderedList.js